export const environment = {
    production: false,
    apiBaseUrl: 'https://api-sting.dev-service.rksting.cz/api',
    apiUsersBaseUrl: 'https://api-sting-users.dev-service.rksting.cz/api',
    apiInternalBaseUrl: 'https://api.dev-service.rksting.cz/api',
}; 
